/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * The type of outcome that fires when a streak milestone is reached
 * @export
 */
export const StreakOutcomeType = {
    REWARD: 'REWARD',
    MULTIPLIER: 'MULTIPLIER',
    BADGE: 'BADGE',
    UNLOCK: 'UNLOCK',
    WEBHOOK: 'WEBHOOK',
    NOTIFICATION: 'NOTIFICATION',
    FEED_EVENT: 'FEED_EVENT'
} as const;
export type StreakOutcomeType = typeof StreakOutcomeType[keyof typeof StreakOutcomeType];


export function instanceOfStreakOutcomeType(value: any): boolean {
    for (const key in StreakOutcomeType) {
        if (Object.prototype.hasOwnProperty.call(StreakOutcomeType, key)) {
            if (StreakOutcomeType[key as keyof typeof StreakOutcomeType] === value) {
                return true;
            }
        }
    }
    return false;
}

export function StreakOutcomeTypeFromJSON(json: any): StreakOutcomeType {
    return StreakOutcomeTypeFromJSONTyped(json, false);
}

export function StreakOutcomeTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): StreakOutcomeType {
    return json as StreakOutcomeType;
}

export function StreakOutcomeTypeToJSON(value?: StreakOutcomeType | null): any {
    return value as any;
}

export function StreakOutcomeTypeToJSONTyped(value: any, ignoreDiscriminator: boolean): StreakOutcomeType {
    return value as StreakOutcomeType;
}

